import { render, staticRenderFns } from "./ui-icon.vue?vue&type=template&id=65bc402f&scoped=true&"
import script from "./ui-icon.vue?vue&type=script&lang=ts&"
export * from "./ui-icon.vue?vue&type=script&lang=ts&"
import style0 from "./ui-icon.vue?vue&type=style&index=0&id=65bc402f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bc402f",
  null
  
)

export default component.exports